// The running release and how to tell that a newer one was deployed. CI builds with
// REACT_APP_VERSION = the git tag; the build also publishes it as `/version.json` (webpack.common.js
// VersionFilePlugin), served no-store by nginx. Comparing the two tells a long-open tab that it runs an
// old release.

/** The release this bundle was built as (`dev` for a local build). */
export const RUNNING_VERSION: string = process.env.REACT_APP_VERSION || 'dev';

/** The version check only makes sense for a real release: never in dev, never without a version. */
export function isVersionCheckEnabled(running: string): boolean {
  return running.trim() !== '' && running !== 'dev';
}

/**
 * The deployed version from a `/version.json` body when it differs from the running one, else null.
 * A malformed or empty body never counts as a new release.
 */
export function newerDeployedVersion(running: string, body: unknown): string | null {
  if (typeof body !== 'object' || body === null) {
    return null;
  }
  const deployed = (body as { version?: unknown }).version;
  if (typeof deployed !== 'string' || deployed.trim() === '' || deployed === 'dev') {
    return null;
  }
  return deployed !== running ? deployed : null;
}
